var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53986 11.3102C8.71379 11.6083 8.61308 11.991 8.31492 12.165L5.2404 13.9584L12 17.9015L18.7596 13.9584L15.6851 12.165C15.3869 11.991 15.2862 11.6083 15.4601 11.3102C15.6341 11.012 16.0168 10.9113 16.3149 11.0852L20.3149 13.4186C20.5069 13.5306 20.625 13.7361 20.625 13.9584C20.625 14.1807 20.5069 14.3863 20.3149 14.4983L12.3149 19.165C12.1203 19.2785 11.8797 19.2785 11.6851 19.165L3.68508 14.4983C3.49307 14.3863 3.375 14.1807 3.375 13.9584C3.375 13.7361 3.49307 13.5306 3.68508 13.4186L7.68508 11.0852C7.98324 10.9113 8.36594 11.012 8.53986 11.3102Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12.3452 6 12.625 6.27982 12.625 6.625L12.625 14.625C12.625 14.9702 12.3452 15.25 12 15.25C11.6548 15.25 11.375 14.9702 11.375 14.625L11.375 6.625C11.375 6.27982 11.6548 6 12 6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5581 5.18306C11.8021 4.93898 12.1979 4.93898 12.4419 5.18306L15.4419 8.18306C15.686 8.42714 15.686 8.82286 15.4419 9.06694C15.1979 9.31102 14.8021 9.31102 14.5581 9.06694L12 6.50888L9.44194 9.06694C9.19786 9.31102 8.80214 9.31102 8.55806 9.06694C8.31398 8.82286 8.31398 8.42714 8.55806 8.18306L11.5581 5.18306Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.0689646b28e2463edc3690f04e860c2b.svg";
export { ForwardRef as ReactComponent };